import * as React from 'react'
import { useFormikContext } from 'formik'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'

import type { FormState } from './formConfig'

type Props = {
  onClose: () => void
}

export function ClosedLostDialogButtons(props: Props) {
  const { onClose } = props

  const { values, isSubmitting, submitForm } = useFormikContext<FormState>()

  const hasReason =
    values.reasonId !== '' &&
    (values.reasonId !== 'custom' || values.customReason.trim().length > 0)

  const disabled = isSubmitting || !hasReason

  return (
    <DialogActions sx={{ p: 3, pt: 1 }}>
      <Button onClick={onClose} data-test-id="closed-lost-cancel-button">
        Close
      </Button>
      <Button
        disabled={disabled}
        onClick={submitForm}
        variant="contained"
        data-test-id="closed-lost-save-button"
      >
        Save
      </Button>
    </DialogActions>
  )
}
